// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__180ws","error":"Textarea_error__3Kvc_","readonly":"Textarea_readonly__2h5fZ","disabled":"Textarea_disabled__2InAZ"};